import React from "react";
import { Row, Col, Typography, Tabs, TabsProps } from "antd";
import { Title } from "../Title/Title";
import { useNavigate } from "react-router-dom";
import { DecarbProjects } from "./DecarbProjects";
import { FinanceFramework } from "./FinanceFramework";

export const InvestmentHub = () => {
  const navigate = useNavigate();

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: `Decarb Projects Directory`,
      children: <DecarbProjects />,
    },
    {
      key: "2",
      label: `Sustainable Finance Framework & Options`,
      children: <FinanceFramework />,
    },
  ];

  const verifyAndRedirect = (linkInfo: any) => {
    if (linkInfo.title === "Country Priority") {
      navigate("/dashboard#investment-asean");
    } else if (linkInfo.title === "Sector Priority") {
      navigate("/dashboard#investment-across-sector");
    } else if (linkInfo.title === "Commercial Finance") {
      navigate(`/financing-products?type=${linkInfo.title}`);
    } else if (linkInfo.title === "Concessional Finance") {
      navigate(`/financing-products?type=${linkInfo.title}`);
    }
  };

  return (
    <>
      <div className="investment-hub" id="investment-hub">
        <Row
          style={{
            background: "#003087",
            padding: "40px 0",
            paddingBottom: 20,
          }}
        >
          <Col lg={2}></Col>
          <Col lg={20} sm={24}>
            <Title title="DECARB PROJECTS HUB​" width={600} />
            <div style={{ marginBottom: 20 }}>
              <Typography.Text className="textSmall" style={{ color: "#fff" }}>
                A hub to support and engage investors and infra
                owners/developers across sectors to access impact funds
                digitally. The decarb projects hub will offer investors access to
                project data and generate investible project names.{" "}
              </Typography.Text>
            </div>
            <div>
              <div
                style={{
                  background:
                    "linear-gradient(89.96deg, #00B8F5 0.03%, rgba(253, 52, 156, 0) 98.14%)",
                  padding: "4px 12px",
                }}
              >
                <Typography.Title
                  style={{
                    color: "#fff",
                    fontWeight: 500,
                    marginBottom: 0,
                  }}
                  level={4}
                >
                  Decarb Projects Directory
                </Typography.Title>
              </div>
              <DecarbProjects />
            </div>
            {/* <div className="decarb-tab" style={{ marginTop: 20 }}>
              <Tabs type="card" defaultActiveKey="1" items={items} />
            </div> */}
          </Col>
          <Col lg={2}></Col>
        </Row>
      </div>
    </>
  );
};
